






































































import {Vue, Component, Prop, Watch, Mixins} from "vue-property-decorator";
import {InvitesDataHelper} from "./helpers/InvitesDataHelper";
import Invite from "./components/Invite.vue";
import {Debounce} from "vue-debounce-decorator";
import {MeetingDataHelper} from "../meeting-view/helper/MeetingDataHelper";
import {Invite as InviteModel} from '@api/models/meetings/Invite';
import {ParticipantStatuses} from "@api/enums/Meetings/ParticipantStatuses";
import {DateTime} from "luxon";
import {EventBus} from "@common/EventBus";
import {ParticipantStatusChange} from "../../types/ParticipantStatusChange";
import {dateInOriginalOffset} from "../../common/dateTimeHelper";
import {formatDate} from "../../common/dateTimeHelper";
import InviteTypes from "./enums/InviteTypes";
import SegmentControl from "../common/segment/Segment.vue";
import { SegmentDataItem } from "../common/segment/SegmentData";
import VueToggleBtn from '../../common/vue-toggle-btn/toggle-btn.vue';
import { TooltipDirective } from '../directives/Tooltip';
import PeriodicRefreshMixin from "@mixins/PeriodicRefreshMixin";
import {IsMeetingsEnabled} from "@mixins/isMeetingsEnabled";
import { PaymentAccess } from "@mixins/PaymentAccess";
import MeetingsEmptyIcon from "../../assets/svg/meetings-empty.svg";
import PanelBackgroundIcon from "@share/common/PanelBackgroundIcon.vue";

import BounceSpinner from "@share/common/BounceSpinner.vue";
import Overlay from "@share/common/Overlay.vue";


@Component({
    name: 'InvitesList',
    components: { Invite, SegmentControl, VueToggleBtn, PanelBackgroundIcon, MeetingsEmptyIcon, BounceSpinner, Overlay },
    directives: { TooltipDirective }
})
export default class InvitesList extends Mixins(PeriodicRefreshMixin, IsMeetingsEnabled, PaymentAccess, Vue) {
    @Prop({required: true}) eventId: string;

    static INVITES_REFRESH_TIMEOUT  = 60 * 1000;
    static INVITES_ACTIVATE_LIMIT_TIMEOUT = 0;

    meetingDataHelper: MeetingDataHelper | null = null;
    selectedInvite?: InviteModel | null = null;
    scrollTo = '';
    isLoaded = false;
    loading = false;
    type = InviteTypes.received;
    segmentTitles: Record<string, any>[] = [];
    isShowCanceled = false;
    newMeetingLoading = false;
    viewDate = DateTime.local(); // выбранная дата, отображается над гридом событий, рядом с пикером даты

    toggleOptions(active: boolean) {
        return {
            isActive: active,
            track: {
                height: 19,
                width: 32,
                activeColor: '#4CD964'
            },
            handle: {
                diameter: 17,
                distance: 50
            }
        }
    }

    get toggleCanceledOptions() {
        return this.toggleOptions(this.isShowCanceled);
    }

    get tooltipProps() {
        return {
            title: this.$t('common.canceled invites tooltip')
        }
    }

    get meetingId() {
        if (this.$route.name == 'Invite') {
            return this.$route.params.id;
        }
        return null;
    }

    get range() {
        return this.$store.getters['meetingsTimeRange'];
    }

    get segmentData(): SegmentDataItem[] {
        return [
            {
                active: this.type === InviteTypes.received,
                title: this.$t('common.received invites').toString(),
                value: InviteTypes.received
            },
            {
                active: this.type === InviteTypes.sended,
                title: this.$t('common.sended invites').toString(),
                value: InviteTypes.sended
            }
        ]
    }

    @Watch('meetingId')
    async onMeetingIdChanged() {
        if (this.meetingId) {
            this.$store.dispatch('showSpinner');
            await this.meetingDataHelper?.setMeeting(this.meetingId);
            this.selectedInvite = this.dataHelper.invites.find((item: any) => item.meetingId == this.meetingId);
            this.$store.dispatch('hideSpinner');
        }
        else {
            this.resetSelectedMeeting();
        }
    }

    created() {
        this.segmentTitles = [
            {
                key: InviteTypes.received,
                title: this.$t('common.received invites')
            },
            {
                key: InviteTypes.sended,
                title: this.$t('common.sended invites')
            }
        ];
    }

    async activated() {
        if (this.isLoaded) {
            this.handleNewMeeting();
        }
        this.subscribe();
    }

    deactivated() {
        this.unsubscribe();
    }

    subscribe() {
        EventBus.$on('newMeeting', this.newMeeting);
    }

    unsubscribe() {
        EventBus.$off('newMeeting', this.newMeeting);
    }

    get offset() {
        return this.$store.state.timeZoneOffset;
    }

    get lang() {
        return this.$store.state.session.language || 'en';
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    get today() {
        return this.viewDate;
    }

    get timeRange() {
        return this.$store.getters['timeRange'];
    }

    get invites(): { [key: string]: InviteModel[] } {
        let invites: InviteModel[] = this.dataHelper?.invites;

        if(invites) {
            const groupedInvites: {[key: string]: InviteModel[]} = {};
            if (this.isShowReceived) {
                invites = invites?.filter(item => item.ownerId != this.userId);
            } else {
                if (!this.isShowCanceled) {
                    invites = invites.filter(invite => !invite.participants.filter(participant => participant.userId !== this.userId)
                        .every(participant => participant?.status?.toLowerCase() === ParticipantStatuses.declined.toString()))
                }
            }
            invites.forEach((item: InviteModel) => {
                const date: string = formatDate(dateInOriginalOffset(item.beginAt as DateTime, this.offset), this.lang);
                if (!groupedInvites[date]) {
                    groupedInvites[date] = [];
                }
                groupedInvites[date].push(item);
            });
            for(const day in groupedInvites) {
                groupedInvites[day].sort((a, b) => {
                    if (!a.beginAt || !b.beginAt) {return 1;}
                    return a.beginAt.diff(b.beginAt).milliseconds;
                })
            }

            return groupedInvites;
        }
        return {}
    }

    get inviteDays() {
        return Object.keys(this.invites).sort((a, b) => {

            const beginAtCurrent = this.invites[a][0].beginAt;
            const beginAtNext = this.invites[b][0].beginAt;

            if(beginAtCurrent && beginAtNext) {
                if (beginAtCurrent > beginAtNext) {
                    return 1;
                }
                if (beginAtCurrent < beginAtNext) {
                    return -1
                }
            }

            return 0;
        });
    }

    get currentDateStr() {
        if (this.today) {
            return dateInOriginalOffset(this.today, this.offset).toISODate()
        }
        return '';
    }

    get programs() {
        return this.$store.state.program.programs;
    }

    get userId() {
        return this.$store.state.session.userId;
    }

    get groupIds() {
        return this.$store.state.session.groupdIds || [];
    }

    get dataHelper(): InvitesDataHelper {
        return this.$store.state.invites.dataHelper;
    }

    get useRealtimeUpdates(): boolean {
        return this.$store.state.invites.useRealtimeUpdates;
    }

    async mounted() {
        this.$store.dispatch('invites/setDataHelper', Vue.observable(new InvitesDataHelper(this.eventId, this.userId, this.$repositories)));

        try {
            this.loading = true;

            if (!this.$store.state.program.savedMeeting) {
                await this.dataHelper.fetchInvites(this.type, this.isShowCanceled);
                this.dataHelper.setDateToLast();
            }
            this.meetingDataHelper = Vue.observable(new MeetingDataHelper(this.userId, this.$repositories));

        }
        catch(e) {
            this.$store.dispatch('reportException', e, {root: true});
        }
        finally {
            this.loading = false;
            this.isLoaded = true;
        }

        this.$nextTick(() => {
            this.handleNewMeeting();
        });

        EventBus.$on('participantStatusChanged', this.participantStatusChanged);
        EventBus.$on('newInvites', this.newInvites);
        EventBus.$on('invites/moveDateTo', this.scrollToInvite);

        if (this.meetingId) {
            this.onMeetingIdChanged();
        }

        if(!this.useRealtimeUpdates) {
            this.initRefresh(() => { this.type === InviteTypes.received && this.dataHelper.fetchInvites(this.type, this.isShowCanceled) },
                InvitesList.INVITES_REFRESH_TIMEOUT,
                () => { this.type === InviteTypes.received && this.dataHelper.fetchInvites(this.type, this.isShowCanceled) },
                InvitesList.INVITES_ACTIVATE_LIMIT_TIMEOUT);
        }
    }

    attachInvitesScrollHandler() {
        this.$refs['invitesList'] && (this.$refs['invitesList'] as HTMLElement).addEventListener('scroll', this.invitesScrollHandler)
    }

    removeInvitesScrollHandler() {
        this.$refs['invitesList'] && (this.$refs['invitesList'] as HTMLElement).removeEventListener('scroll', this.invitesScrollHandler);
    }

    @Debounce(500)
    invitesScrollHandler() {
        const isBottom = (this.$refs['invitesList'] as HTMLElement).scrollTop + (this.$refs['invitesList'] as HTMLElement).clientHeight === (this.$refs['invitesList'] as HTMLElement).scrollHeight;
        if (isBottom && !this.dataHelper?.isLoading && (this.dataHelper?.count as number) > (this.dataHelper?.invites as []).length) {
            this.dataHelper && this.dataHelper.page && (this.dataHelper.page++);
            this.dataHelper?.fetchInvites(this.type, this.isShowCanceled);
        }
    }

    async changeStatus(data: any) {
        this.$store.dispatch('showSpinner');
        try {
            const invite = this.dataHelper.inviteById(data.participantId),
                  previousStatus = invite ? invite.status : '',
                  meetingInvite: InviteModel = this.dataHelper?.inviteByMeetingId(data.id) as InviteModel;

            await this.dataHelper.changeStatus(data.id, data.participantId, data.status);
            this.$emit('statusChanged');
            EventBus.$emit('participantStatusChanged', {
                participantId: data.participantId,
                meetingId: data.id,
                status: data.status,
                previousStatus: previousStatus,
                beginAt: meetingInvite.beginAt
            } as ParticipantStatusChange)
        }
        catch (e) {
            this.$store.dispatch('reportException', e);
        }
        this.$store.dispatch('hideSpinner');
    }

    changeStatusFromMeeting(status: ParticipantStatuses) {
        this.$emit('changeStatus', {
            id: this.selectedInvite?.meetingId,
            status: status,
            participantId: this.selectedInvite?.id
        });
    }

    async selectMeeting(invite: InviteModel) {
        this.$emit("selectMeeting", invite.meetingId);
    }

    resetSelectedMeeting() {
        this.selectedInvite = null;
        this.meetingDataHelper?.reset();
        EventBus.$emit('modalClosed');
    }

    closeMeeting() {
        this.$router.push({
            name: 'Invites',
            params: {
                backend: this.$route.params.backend,
            }
        });
    }

    dateChanged(date: DateTime) {
        this.$emit('dateChange', date);
    }

    doInviteHover(invite: InviteModel, newMeeting = false) {
        if (invite && invite.beginAt && !this.newMeetingLoading) {
            this.newMeetingLoading = newMeeting;
            this.scrollTo = (invite.beginAt as DateTime).toFormat('HH:mm:00');
            this.viewDate = invite.beginAt as DateTime;
        }
    }

    @Debounce(500)
    onInviteHover(invite: InviteModel) {
        this.doInviteHover(invite);
    }

    participantStatusChanged(data: ParticipantStatusChange) {
        this.dataHelper.updateStatus(data.meetingId, data.participantId, data.status);
    }

    async newInvites(amount: number) {
        if (amount) {
            await this.dataHelper.fetchInvites(this.type, this.isShowCanceled);
        }
    }

    destroyed() {
        this.removeInvitesScrollHandler();
        EventBus.$off('participantStatusChanged', this.participantStatusChanged);
        EventBus.$off('newInvites', this.newInvites);
        EventBus.$off('invites/moveDateTo', this.scrollToInvite);
    }

    @Watch('type')
    async onTypeChanged() {
        if (!this.newMeetingLoading) {
            await this.dataHelper.fetchInvites(this.type, this.isShowCanceled);
        }
    }

    @Watch('isShowCanceled')
    async onShowCanceledChanged() {
        if (this.type === InviteTypes.received) {
            await this.dataHelper.fetchInvites(this.type, this.isShowCanceled);
        }
    }

    get isShowReceived() {
        return this.type == InviteTypes.received;
    }

    private onSwitchType(value: string) {
        this.type = value;
    }

    setShowCanceled(value: boolean) {
        this.isShowCanceled = value;
    }

    showEdit() {
        this.selectedInvite && (this.$router.push({
            name: 'EditMeeting',
            params: {
                backend: this.$route.params.backend,
                id: this.selectedInvite.meetingId
            }
        }));
    }

    async handleNewMeeting() {
        if (this.$store.state.program.savedMeeting && !this.newMeetingLoading) {
            this.$store.state.program.savedMeeting.meetingId = this.$store.state.program.savedMeeting.id;
            await this.scrollToInvite(this.$store.state.program.savedMeeting);
        }
    }

    async scrollToInvite(invite: InviteModel) {
        if (!invite.meetingId) {
            invite.meetingId = invite.id
        }
        this.$store.dispatch('showSpinner');
        try {
            await this.doInviteHover(invite, true);
        }
        catch (e) {
            this.$store.dispatch('reportError', e);
        }

        this.type = InviteTypes.sended;
        await this.dataHelper.fetchInvites(InviteTypes.sended, this.isShowCanceled);

        const meetingId = invite.id;
        this.$nextTick(() => {
            if (this.$refs[`invite${meetingId}`]) {
                const element = (this.$refs[`invite${meetingId}`] as any)[0]?.$el as HTMLElement;
                const list = this.$refs['invitesList'] as HTMLElement;

                if (element && list) {
                    list.scrollTop = element.offsetTop - 100; // scroll list
                }
            }
        });
        this.$store.dispatch('hideSpinner');
        setTimeout(() => {
            this.newMeetingLoading = false
        }, 2000);
    }

    newMeeting(data: any = undefined) {
        if (this.showPayButtonInsteadMeetings) {
            this.showPayMessage();
            return;
        }

        const date = data.date || this.viewDate.toISODate();
        this.$emit('newMeeting', {time: data.time, date: date});
    }
}
